var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconZip32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 26A2.75 2.75 0 0010 28.75h14A2.75 2.75 0 0026.75 26V9.998a.75.75 0 00-.22-.53l-6.002-5.999a.75.75 0 00-.53-.219H10A2.75 2.75 0 007.25 6v7a.75.75 0 001.5 0V6c0-.69.56-1.25 1.25-1.25h9V9a2 2 0 002 2h4.25v15c0 .69-.56 1.25-1.25 1.25H10c-.69 0-1.25-.56-1.25-1.25v-1a.75.75 0 00-1.5 0v1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.048 20.983h-2.79l2.754-3.681v-.828H5.827v1.008h2.727l-2.772 3.681V22h4.266v-1.017zm2.541-4.509h-1.152V22h1.152v-5.526z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.337 18.283c0 1.17-.774 1.8-1.944 1.8h-1.107V22h-1.143v-5.526h2.25c1.17 0 1.944.63 1.944 1.809zm-2.016.819c.594 0 .882-.342.882-.819 0-.495-.288-.828-.882-.828h-1.035v1.647h1.035z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconZip32);
export default __webpack_public_path__ + "static/media/icon-zip-32.ff30f282.svg";
export { ForwardRef as ReactComponent };